/* Wrought seasonal extras: October eyes, embers, cobwebs, spider, bats and the Oct 31 flashlight, November bar + accents + leaves,
   December trees + snowfall. October/December classes are set on <html> by
   snippets/wrought-polish.liquid; November is set here (or with ?preview=november). */
(function () {
  var root = document.documentElement;
  if (new Date().getMonth() === 10 || /[?&]preview=november/.test(location.search)) root.classList.add('wr-november');
  if (!root.classList.contains('wr-october') && !root.classList.contains('wr-november') && !root.classList.contains('wr-december')) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var style = document.createElement('style');
  style.textContent = ".wr-eyes { position: absolute; width: calc(38px * var(--s, 1)); height: calc(13px * var(--s, 1)); transform: translateY(-50%); opacity: 0; transition: opacity 1.2s ease; pointer-events: none; z-index: 4; } .wr-eyes.is-open { opacity: 1; } .wr-eyes svg { width: 100%; height: 100%; overflow: visible; filter: drop-shadow(0 0 3px rgba(255, 120, 40, .7)); } .wr-eye { transform-box: fill-box; transform-origin: center; transition: transform .12s ease; } .wr-eye path { fill: #ff8a3d; } .wr-pupil { fill: #140803; transform: translate(var(--px, 0), var(--py, 0)); transition: transform .25s ease; } .wr-eyes.is-blink .wr-eye { transform: scaleY(.08); } .wr-tree { position: absolute; bottom: 3px; pointer-events: none; overflow: visible; } .wr-tree--l { right: calc(100% + 10px); width: 30px; } .wr-tree--r { left: calc(100% + 10px); width: 24px; } .wr-tree__leaf { fill: #1f3b2a; } .wr-tree__trunk { fill: #3b2c1c; } .wr-tree__snow { fill: #eeeae0; } .wr-tree__star { fill: #e8b04a; } .wr-tree__light { fill: #e8b04a; animation: wr-twinkle 2.4s ease-in-out infinite; } .wr-tree__light:nth-of-type(2n) { fill: #c94a3a; animation-delay: -.8s; } .wr-tree__light:nth-of-type(3n) { fill: #f2ede1; animation-delay: -1.6s; } .wr-snow { position: fixed; inset: 0; width: 100%; height: 100%; pointer-events: none; z-index: 2147482000; } @keyframes wr-twinkle { 0%,100% { opacity: 1; } 50% { opacity: .35; } } @media (prefers-reduced-motion: reduce) { .wr-tree__light { animation: none; } }";
  document.head.appendChild(style);

  // ---------- October: eyes in the dark ----------
  function initEyes() {
    if (!document.documentElement.classList.contains('wr-october')) return;
    var header = document.querySelector('#header-component');
    var logo = header && header.querySelector('.header-logo__image-container');
    if (!header || !logo || header.querySelector('.wr-eyes')) return;
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';

    var EYE =
      '<svg viewBox="0 0 30 10" aria-hidden="true">' +
      '<g class="wr-eye"><path d="M1 5 Q6 0.5 11 5 Q6 9.5 1 5 Z"/><ellipse class="wr-pupil" cx="6" cy="5" rx="1" ry="3"/></g>' +
      '<g class="wr-eye"><path d="M19 5 Q24 0.5 29 5 Q24 9.5 19 5 Z"/><ellipse class="wr-pupil" cx="24" cy="5" rx="1" ry="3"/></g>' +
      '</svg>';
    var pairs = [];
    for (var i = 0; i < 2; i++) {
      var el = document.createElement('div');
      el.className = 'wr-eyes';
      el.innerHTML = EYE;
      header.appendChild(el);
      pairs.push(el);
    }

    function place(el, side) {
      var h = header.getBoundingClientRect();
      var l = logo.getBoundingClientRect();
      var gapL = l.left - h.left - 60, gapR = h.right - l.right - 60;
      var room = side ? gapR : gapL;
      if (room < 90) { el.classList.remove('is-open'); return false; }
      var x = side
        ? l.right - h.left + 55 + Math.random() * (room - 110)
        : 60 + 20 + Math.random() * (room - 110);
      el.style.left = Math.round(x) + 'px';
      el.style.top = Math.round(h.height * (0.3 + Math.random() * 0.25)) + 'px';
      el.style.setProperty('--s', (0.8 + Math.random() * 0.45).toFixed(2));
      return true;
    }

    function cycle(el, side) {
      if (reduce) { if (place(el, side)) el.classList.add('is-open'); return; }
      var wait = 1500 + Math.random() * 5000;
      setTimeout(function () {
        if (!place(el, side)) return setTimeout(function () { cycle(el, side); }, 3000);
        el.classList.add('is-open');
        var blinks = 1 + Math.floor(Math.random() * 3);
        for (var b = 0; b < blinks; b++) {
          setTimeout(function () {
            el.classList.add('is-blink');
            setTimeout(function () { el.classList.remove('is-blink'); }, 140);
          }, 900 + b * (700 + Math.random() * 900));
        }
        setTimeout(function () {
          el.classList.remove('is-open');
          setTimeout(function () { cycle(el, side); }, 900);
        }, 3500 + Math.random() * 3000);
      }, wait);
    }
    cycle(pairs[0], 0);
    cycle(pairs[1], 1);

    // Pupils follow the pointer.
    var raf = null;
    window.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        pairs.forEach(function (p) {
          var r = p.getBoundingClientRect();
          var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
          var len = Math.max(1, Math.sqrt(dx * dx + dy * dy));
          p.style.setProperty('--px', ((dx / len) * 2.4).toFixed(2) + 'px');
          p.style.setProperty('--py', ((dy / len) * 1.2).toFixed(2) + 'px');
        });
      });
    }, { passive: true });
  }

  // ---------- October extras: embers, cobwebs, spider, bats, Halloween-night flashlight ----------
  var HW_CSS =
    // Click sparks become embers and the cursor glow warms up.
    '.wr-october .wrought-spark { background: #ff8a3d; box-shadow: 0 0 6px 1px rgba(255, 110, 30, .8); }' +
    '.wr-october .wrought-glow { background: radial-gradient(320px circle at var(--wrought-mx, 50%) var(--wrought-my, 50%), rgba(255, 120, 40, .09), transparent 70%); }' +
    // Cobwebs in the header's top corners.
    '.wr-web { position: absolute; top: 0; width: 64px; height: 64px; pointer-events: none; z-index: 3; opacity: .5; }' +
    '.wr-web--l { left: 0; } .wr-web--r { right: 0; transform: scaleX(-1); }' +
    '.wr-web path { fill: none; stroke: #bdb9ae; stroke-width: .6; }' +
    // Spider on a thread.
    '.wr-spider { position: absolute; top: 100%; width: 22px; pointer-events: none; z-index: 7; transform-origin: 50% 0; animation: wr-bob 4.5s ease-in-out infinite; }' +
    '.wr-spider__line { position: absolute; left: 50%; bottom: 100%; width: 1px; background: linear-gradient(#bdb9ae55, #bdb9aeaa); }' +
    '.wr-spider svg { display: block; width: 22px; overflow: visible; }' +
    '.wr-spider { transition: top 1.1s cubic-bezier(.3,.7,.2,1); }' +
    '@keyframes wr-bob { 0%,100% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(6px) rotate(3deg); } }' +
    // Bats.
    '.wr-bat { position: absolute; top: 0; left: 0; width: 34px; pointer-events: none; z-index: 2; filter: drop-shadow(0 0 3px rgba(255, 130, 50, .45)); }' +
    '.wr-bat svg { width: 100%; overflow: visible; }' +
    '.wr-bat .wing { transform-origin: 50% 40%; animation: wr-flap .22s ease-in-out infinite alternate; }' +
    '@keyframes wr-flap { from { transform: scaleY(1); } to { transform: scaleY(-.35); } }' +
    // Halloween night: flashlight.
    '#wr-dark { position: fixed; inset: 0; z-index: 2147481000; pointer-events: none; background: rgba(0, 0, 0, .93);' +
    ' -webkit-mask-image: radial-gradient(circle 150px at var(--fx, 50%) var(--fy, 40%), transparent 0%, transparent 55%, #000 100%);' +
    ' mask-image: radial-gradient(circle 150px at var(--fx, 50%) var(--fy, 40%), transparent 0%, transparent 55%, #000 100%);' +
    ' transition: opacity .8s ease; }' +
    '#wr-dark.is-off { opacity: 0; }' +
    '#wr-lights-on { position: fixed; left: 16px; bottom: 16px; z-index: 2147481001; background: #0b0b0b; color: #F0997B; border: 1px solid #712B13; font: 11px/1 var(--font-body--family, sans-serif); letter-spacing: .2em; text-transform: uppercase; padding: 10px 14px; cursor: pointer; }' +
    '#wr-lights-on:focus-visible { outline: 2px solid #F0997B; outline-offset: 2px; }' +
    '@media (prefers-reduced-motion: reduce) { .wr-spider, .wr-bat .wing { animation: none; } }';

  var WEB =
    '<svg class="wr-web {cls}" viewBox="0 0 64 64" aria-hidden="true"><path d="' +
    'M0 0 L60 8 M0 0 L48 30 M0 0 L28 50 M0 0 L8 60 ' +
    'M14 2 Q12 8 11 12 Q7 12 2 14 ' +
    'M28 4 Q24 14 22 22 Q12 24 4 28 ' +
    'M42 6 Q36 20 33 32 Q18 36 6 42 ' +
    'M56 7 Q48 26 44 40 Q24 46 7 56"/></svg>';

  var SPIDER =
    '<svg viewBox="0 0 22 20" aria-hidden="true">' +
    '<g stroke="#3a3835" stroke-width="1.1" fill="none" stroke-linecap="round">' +
    '<path d="M8 8 Q3 4 1 7 M8 10 Q2 9 0 12 M8 12 Q3 14 2 18 M9 13 Q6 17 6 20"/>' +
    '<path d="M14 8 Q19 4 21 7 M14 10 Q20 9 22 12 M14 12 Q19 14 20 18 M13 13 Q16 17 16 20"/>' +
    '</g><ellipse cx="11" cy="7" rx="3" ry="2.6" fill="#3a3835"/><ellipse cx="11" cy="12.5" rx="4.2" ry="4.8" fill="#3a3835"/>' +
    '<circle cx="10" cy="6.6" r=".7" fill="#ff8a3d"/><circle cx="12" cy="6.6" r=".7" fill="#ff8a3d"/></svg>';

  var BAT =
    '<svg viewBox="0 0 40 18" aria-hidden="true"><g fill="#2c2a27">' +
    '<path class="wing" d="M20 8 Q14 1 2 3 Q7 6 6 10 Q10 8 13 11 Q15 8 20 10 Q25 8 27 11 Q30 8 34 10 Q33 6 38 3 Q26 1 20 8 Z"/>' +
    '<ellipse cx="20" cy="10" rx="2.6" ry="3.4"/><path d="M18.3 7.4 L18.8 5.6 L19.6 7 Z M21.7 7.4 L21.2 5.6 L20.4 7 Z"/>' +
    '</g></svg>';

  function initHalloweenExtras() {
    var root = document.documentElement;
    if (!root.classList.contains('wr-october')) return;
    var st = document.createElement('style');
    st.textContent = HW_CSS;
    document.head.appendChild(st);

    var header = document.querySelector('#header-component');
    if (header && !header.querySelector('.wr-web')) {
      if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
      header.insertAdjacentHTML('beforeend', WEB.replace('{cls}', 'wr-web--l') + WEB.replace('{cls}', 'wr-web--r'));
    }

    // Spider: dangles below the header on the right, climbs up when the pointer gets close.
    if (header && !header.querySelector('.wr-spider')) {
      var sp = document.createElement('div');
      sp.className = 'wr-spider';
      sp.innerHTML = '<span class="wr-spider__line"></span>' + SPIDER;
      sp.style.right = '18%';
      header.appendChild(sp);
      var line = sp.querySelector('.wr-spider__line');
      var drop = 70;
      function setDrop(d) {
        drop = d;
        sp.style.top = 'calc(100% + ' + d + 'px)';
        line.style.height = (d + 2) + 'px';
      }
      setDrop(70);
      if (!reduce && window.matchMedia('(pointer: fine)').matches) {
        var hiding = false;
        window.addEventListener('pointermove', function (e) {
          var r = sp.getBoundingClientRect();
          var near = Math.abs(e.clientX - (r.left + r.width / 2)) < 90 && Math.abs(e.clientY - (r.top + r.height / 2)) < 90;
          if (near && !hiding) { hiding = true; setDrop(4); setTimeout(function () { hiding = false; setDrop(40 + Math.random() * 60); }, 2600); }
        }, { passive: true });
      }
    }

    // Bats: one crosses the hero every so often.
    var hero = document.querySelector('.wr-hero-first') || document.querySelector('main .hero-wrapper');
    if (hero && !reduce) {
      if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
      function flyBat() {
        var b = document.createElement('div');
        b.className = 'wr-bat';
        b.innerHTML = BAT;
        var h = hero.getBoundingClientRect();
        var fromLeft = Math.random() < 0.5;
        var y0 = h.height * (0.12 + Math.random() * 0.3);
        var scale = 0.7 + Math.random() * 0.6;
        b.style.width = Math.round(34 * scale) + 'px';
        hero.appendChild(b);
        var x0 = fromLeft ? -50 : h.width + 50, x1 = fromLeft ? h.width + 50 : -50;
        var dur = 5200 + Math.random() * 2500;
        var anim = b.animate([
          { transform: 'translate(' + x0 + 'px,' + y0 + 'px)' },
          { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (y0 - 40 - Math.random() * 40) + 'px)' },
          { transform: 'translate(' + x1 + 'px,' + (y0 + 20) + 'px)' }
        ], { duration: dur, easing: 'ease-in-out' });
        anim.onfinish = function () { b.remove(); };
        setTimeout(flyBat, 14000 + Math.random() * 16000);
      }
      setTimeout(flyBat, 3500);
    }

    // Halloween night (Oct 31, visitor's local time), or ?preview=october&night=1 to preview: lights out, flashlight cursor.
    var now = new Date();
    var isNight = (now.getMonth() === 9 && now.getDate() === 31) || /[?&](preview=halloween|night=1)/.test(location.search);
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('wrLightsOn') === '1'; } catch (e) {}
    if (isNight && !dismissed && !document.getElementById('wr-dark')) {
      var dark = document.createElement('div');
      dark.id = 'wr-dark';
      dark.setAttribute('aria-hidden', 'true');
      document.body.appendChild(dark);
      var btn = document.createElement('button');
      btn.id = 'wr-lights-on';
      btn.type = 'button';
      btn.textContent = 'Turn the lights on';
      document.body.appendChild(btn);
      btn.addEventListener('click', function () {
        dark.classList.add('is-off');
        btn.remove();
        try { sessionStorage.setItem('wrLightsOn', '1'); } catch (e) {}
        setTimeout(function () { dark.remove(); }, 900);
      });
      var tx = window.innerWidth / 2, ty = window.innerHeight * 0.4, cx = tx, cy = ty, pending = false;
      function move(x, y) { tx = x; ty = y; if (!pending) { pending = true; requestAnimationFrame(step); } }
      function step() {
        cx += (tx - cx) * 0.25; cy += (ty - cy) * 0.25;
        dark.style.setProperty('--fx', cx + 'px');
        dark.style.setProperty('--fy', cy + 'px');
        if (Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) requestAnimationFrame(step); else pending = false;
      }
      window.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); }, { passive: true });
      window.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
      move(tx, ty);
    }
  }

  // ---------- December: trees + snow ----------
  var TREE =
    '<path class="wr-tree__trunk" d="M18 38 L22 38 L22 43 L18 43 Z"/>' +
    '<path class="wr-tree__leaf" d="M20 4 L29 16 L25 16 L33 27 L28 27 L37 38 L3 38 L12 27 L7 27 L15 16 L11 16 Z"/>' +
    '<path class="wr-tree__snow" d="M20 4 L24 9.5 Q20 8 16 9.5 Z M15 16 L25 16 L27 18.5 Q20 17 13 18.5 Z M12 27 L28 27 L30 29.5 Q20 28 10 29.5 Z"/>' +
    '<circle class="wr-tree__light" cx="17" cy="14" r="1"/><circle class="wr-tree__light" cx="24" cy="22" r="1"/>' +
    '<circle class="wr-tree__light" cx="14" cy="33" r="1"/><circle class="wr-tree__light" cx="27" cy="34" r="1"/>' +
    '<circle class="wr-tree__light" cx="20" cy="25" r="1"/>' +
    '<path class="wr-tree__star" d="M20 0.5 L21 3 L23.5 3 L21.5 4.5 L22.3 7 L20 5.5 L17.7 7 L18.5 4.5 L16.5 3 L19 3 Z"/>';

  function initTrees() {
    if (!document.documentElement.classList.contains('wr-december')) return;
    var box = document.querySelector('#header-component .header-logo__image-container');
    if (!box || box.querySelector('.wr-tree')) return;
    ['wr-tree--l', 'wr-tree--r'].forEach(function (cls) {
      box.insertAdjacentHTML('beforeend', '<svg class="wr-tree ' + cls + '" viewBox="0 0 40 44" aria-hidden="true">' + TREE + '</svg>');
    });
  }

  function initSnow() {
    if (!document.documentElement.classList.contains('wr-december') || reduce) return;
    if (document.querySelector('.wr-snow')) return;
    var c = document.createElement('canvas');
    c.className = 'wr-snow';
    c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H, flakes = [];
    function size() {
      W = window.innerWidth; H = window.innerHeight;
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, W / 12));
      while (flakes.length < n) flakes.push(make(true));
      flakes.length = n;
    }
    function make(anywhere) {
      return {
        x: Math.random() * W,
        y: anywhere ? Math.random() * H : -5,
        r: 0.6 + Math.random() * 1.8,
        v: 0.25 + Math.random() * 0.6,
        w: Math.random() * Math.PI * 2,
        a: 0.25 + Math.random() * 0.5
      };
    }
    size();
    window.addEventListener('resize', size, { passive: true });
    var running = true;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(tick);
    });
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.v;
        f.w += 0.01;
        f.x += Math.sin(f.w) * 0.3;
        if (f.y > H + 5) flakes[i] = f = make(false);
        // Fade out toward the bottom so it never fights the products.
        var fade = Math.max(0, 1 - f.y / (H * 0.9));
        ctx.globalAlpha = f.a * fade;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = '#f2ede1';
        ctx.fill();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // ---------- November: bar, amber accents, leaf sprigs, maple leaves ----------
  var NOV_CSS =
    '#wr-nov-bar { display: block; background: #15100a; border-bottom: 1px solid #3a2a14; color: #d9a55a; text-align: center; font-size: 12px; letter-spacing: .3em; text-transform: uppercase; padding: 9px 12px; }' +
    '.wr-november [class*="button-custom"] { background: transparent !important; border: 1px solid #c9822e !important; color: #e0ad63 !important; }' +
    '.wr-november [class*="button-custom"]:hover { background: #c9822e !important; color: #0b0b0b !important; }' +
    '.wr-november product-price, .wr-november .price { color: #e0ad63 !important; }' +
    '.wr-november #header-group img { filter: drop-shadow(0 0 6px rgba(201, 130, 46, .5)); }' +
    '.wr-sprig { position: absolute; bottom: 2px; pointer-events: none; overflow: visible; }' +
    '.wr-sprig--l { right: calc(100% + 6px); width: 40px; }' +
    '.wr-sprig--r { left: calc(100% + 6px); width: 40px; transform: scaleX(-1); }' +
    '.wr-sprig .sway { transform-origin: 90% 90%; animation: wr-sway 5s ease-in-out infinite; }' +
    '.wr-sprig--r .sway { animation-delay: -2.2s; }' +
    '@keyframes wr-sway { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(-4deg); } }' +
    '@media (prefers-reduced-motion: reduce) { .wr-sprig .sway { animation: none; } }';

  // A small maple leaf, centered at 0,0, about 20 units wide.
  var MAPLE = 'M0 -10 L2 -5 L6 -7 L5 -2 L10 -3 L7 1 L9 3 L3 3 L4 7 L0 5 L-4 7 L-3 3 L-9 3 L-7 1 L-10 -3 L-5 -2 L-6 -7 L-2 -5 Z';
  var SPRIG =
    '<g class="sway">' +
    '<path d="M36 34 Q24 26 10 22" fill="none" stroke="#5a3d1e" stroke-width="1.4" stroke-linecap="round"/>' +
    '<path d="M24 27 Q22 20 24 14" fill="none" stroke="#5a3d1e" stroke-width="1"/>' +
    '<g transform="translate(9 20) rotate(-25) scale(.9)"><path d="' + MAPLE + '" fill="#a4461f"/></g>' +
    '<g transform="translate(24 11) rotate(15) scale(.75)"><path d="' + MAPLE + '" fill="#c9822e"/></g>' +
    '<g transform="translate(18 31) rotate(-60) scale(.6)"><path d="' + MAPLE + '" fill="#7e2a17"/></g>' +
    '<g transform="translate(31 29)"><ellipse cx="0" cy="1.5" rx="2.6" ry="3.2" fill="#8f5a24"/><path d="M-3 -0.5 Q0 -3.5 3 -0.5 Z" fill="#4a3217"/></g>' +
    '</g>';

  function initNovember() {
    if (!document.documentElement.classList.contains('wr-november')) return;
    var st = document.createElement('style');
    st.textContent = NOV_CSS;
    document.head.appendChild(st);
    if (!document.getElementById('wr-nov-bar')) {
      var bar = document.createElement('div');
      bar.id = 'wr-nov-bar';
      bar.setAttribute('role', 'note');
      bar.innerHTML = 'Grateful, not satisfied &nbsp;/&nbsp; November';
      var anchor = document.getElementById('wr-bar') || document.querySelector('.page-wrapper');
      if (anchor) anchor.parentNode.insertBefore(bar, anchor);
    }
    var box = document.querySelector('#header-component .header-logo__image-container');
    if (box && !box.querySelector('.wr-sprig')) {
      ['wr-sprig--l', 'wr-sprig--r'].forEach(function (cls) {
        box.insertAdjacentHTML('beforeend', '<svg class="wr-sprig ' + cls + '" viewBox="0 0 40 40" aria-hidden="true">' + SPRIG + '</svg>');
      });
    }
  }

  // ---------- November: falling leaves across the header ----------
  function initLeaves() {
    if (!document.documentElement.classList.contains('wr-november') || reduce) return;
    var header = document.querySelector('#header-component');
    if (!header || document.querySelector('.wr-leaves')) return;
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';

    var DROP = 170; // how far below the header leaves fall before fading out
    var c = document.createElement('canvas');
    c.className = 'wr-leaves';
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:absolute;left:0;top:0;width:100%;pointer-events:none;z-index:6;';
    header.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var colors = ['#a4461f', '#c9822e', '#7e2a17', '#b8912f', '#8f5a24'];
    var W, H, leaves = [];

    function size() {
      W = header.getBoundingClientRect().width;
      H = header.getBoundingClientRect().height + DROP;
      c.style.height = H + 'px';
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.max(8, Math.min(18, Math.round(W / 70)));
      while (leaves.length < n) leaves.push(make(true));
      leaves.length = n;
    }
    function make(anywhere) {
      return {
        x: Math.random() * W,
        y: anywhere ? Math.random() * H * 0.6 : -12 - Math.random() * 40,
        s: 5 + Math.random() * 6,              // size
        maple: Math.random() < 0.6,
        vy: 0.22 + Math.random() * 0.3,         // fall speed
        vx: 0.15 + Math.random() * 0.35,        // drift (wind to the right)
        sway: Math.random() * Math.PI * 2,
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.03,
        flip: Math.random() * Math.PI * 2,
        vf: 0.02 + Math.random() * 0.03,
        c: colors[Math.floor(Math.random() * colors.length)]
      };
    }
    var maple = window.Path2D ? new Path2D(MAPLE) : null;
    function drawLeaf(f) {
      var s = f.s;
      ctx.save();
      ctx.translate(f.x, f.y);
      ctx.rotate(f.rot);
      ctx.scale(Math.cos(f.flip), 1); // tumbling in 3D
      if (f.maple && maple) {
        ctx.scale(s / 9, s / 9);
        ctx.fillStyle = f.c;
        ctx.fill(maple);
        ctx.beginPath();
        ctx.moveTo(0, -6); ctx.lineTo(0, 9);
        ctx.strokeStyle = 'rgba(40, 18, 8, .5)';
        ctx.lineWidth = 0.8;
        ctx.stroke();
      } else {
        ctx.beginPath();
        ctx.moveTo(0, -s * 1.3);
        ctx.bezierCurveTo(s * 0.9, -s * 0.8, s * 0.9, s * 0.5, 0, s * 1.1);
        ctx.bezierCurveTo(-s * 0.9, s * 0.5, -s * 0.9, -s * 0.8, 0, -s * 1.3);
        ctx.fillStyle = f.c;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(0, -s * 1.1);
        ctx.lineTo(0, s * 1.6);
        ctx.strokeStyle = 'rgba(40, 18, 8, .55)';
        ctx.lineWidth = 0.7;
        ctx.stroke();
      }
      ctx.restore();
    }
    size();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(size, 200); }, { passive: true });
    var running = true;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(tick);
    });
    var gust = 0, gustT = 0;
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      // Every so often a gust of wind pushes the leaves along faster.
      gustT -= 1;
      if (gustT <= 0) { gustT = 480 + Math.random() * 600; gust = 1.6 + Math.random() * 1.2; }
      gust *= 0.985;
      for (var i = 0; i < leaves.length; i++) {
        var f = leaves[i];
        f.sway += 0.015;
        f.y += f.vy;
        f.x += f.vx + gust + Math.sin(f.sway) * 0.45;
        f.rot += f.vr * (1 + gust);
        f.flip += f.vf;
        if (f.y > H + 12 || f.x > W + 20) { leaves[i] = f = make(false); f.x = Math.random() * W * 0.9 - W * 0.1; }
        var fade = Math.min(1, Math.max(0, (H - f.y) / (DROP * 0.8)));
        ctx.globalAlpha = 0.85 * fade;
        drawLeaf(f);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    try { initEyes(); } catch (e) {}
    try { initHalloweenExtras(); } catch (e) {}
    try { initTrees(); } catch (e) {}
    try { initSnow(); } catch (e) {}
    try { initNovember(); } catch (e) {}
    try { initLeaves(); } catch (e) {}
  });
})();
